export default __webpack_public_path__ + "static/media/pexels-photo-55787DonaldTong.18b3e726.jpeg";